import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarDespesa from "./CadastrarDespesa";

const EditarDespesa = () => {
    const { id } = useParams();
    return <CadastrarDespesa despesaId={id} />;
};

export default EditarDespesa;
